import React from "react";

/**
 * 💀 SidebarMenuSkeleton
 *
 * Placeholder visual que simula un ítem de menú
 * mientras los datos reales se cargan.
 */
const SidebarMenuSkeleton: React.FC = () => {
  return (
    <div className="relative flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium bg-graydark/40 animate-pulse">
      {/* 🔹 Línea lateral simulada */}
      <span className="absolute left-0 top-0 h-full w-1 bg-gray-700/40 rounded-r-md"></span>

      {/* 🔸 Bloque simulando el texto */}
      <div className="h-3 w-28 rounded bg-gray-600/70"></div>
    </div>
  );
};

export default SidebarMenuSkeleton;
